
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"15","viewBox":"0 0 12 15","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.76121 14.0429C10.0044 14.0429 11.0215 13.0258 11.0215 11.7826V4.34238V4.26709C11.0215 4.23943 11.0114 4.22196 10.9985 4.19973L10.9985 4.19971C10.9938 4.19164 10.9888 4.18293 10.9838 4.17288C10.9838 4.17288 10.9838 4.15409 10.965 4.15409C10.9463 4.11664 10.9275 4.09785 10.9089 4.07919L10.9085 4.07881L7.25432 0.612995C7.23553 0.594207 7.21661 0.575286 7.17903 0.556497C7.17903 0.556497 7.16024 0.556497 7.16024 0.537709C7.14149 0.528364 7.12741 0.523667 7.11336 0.518978C7.09916 0.51424 7.08499 0.50951 7.06604 0.5H7.04725H6.99075H2.28176C1.03856 0.5 0.0214844 1.51707 0.0214844 2.76028V11.7639C0.0214844 13.0071 1.03856 14.0241 2.28176 14.0241H8.76133L8.76121 14.0429ZM7.36719 1.76562L9.70288 3.95063L7.36719 3.9505V1.76562ZM0.774448 2.78035V11.7839L0.774414 11.7839C0.774414 12.6127 1.45251 13.2908 2.28132 13.2908H8.76089C9.5897 13.2908 10.2678 12.6127 10.2678 11.7839V4.72041H6.99031C6.78312 4.72041 6.61362 4.55093 6.61362 4.34373V1.27344H2.28136C1.45254 1.27344 0.774448 1.95153 0.774448 2.78035Z"}}),_c('path',{attrs:{"d":"M2.75266 8.30025H5.86052C6.06773 8.30025 6.23721 8.13075 6.23721 7.92356C6.23721 7.71636 6.06772 7.54688 5.86052 7.54688H2.75266C2.54546 7.54688 2.37598 7.71637 2.37598 7.92356C2.37598 8.13076 2.54547 8.30025 2.75266 8.30025Z"}}),_c('path',{attrs:{"d":"M2.75266 10.9565H8.30926C8.51647 10.9565 8.68595 10.787 8.68595 10.5798C8.68595 10.3726 8.51646 10.2031 8.30926 10.2031H2.75266C2.54546 10.2031 2.37598 10.3726 2.37598 10.5798C2.37598 10.787 2.54547 10.9565 2.75266 10.9565Z"}})])
          )
        }
      }
    